import { createContext } from "react";
const sTypes = {
  desktop: false,
  tablet: false,
  mobile: false,
};
const ScreenType = createContext(sTypes);
export { ScreenType };
